//#region src/engine/modules/index/actions.ts
var ActionType = {
	addIndex: "index.add",
	removeIndex: "index.remove",
	changeIndexName: "index.changeName",
	changeIndexUnique: "index.changeUnique"
};
//#endregion
export { ActionType };
